export const sortByExplicitOrder = <T extends { _id: string }>(
    items: T[],
    orderedIds: string[]
): T[] => {
    const positionById = new Map(
        orderedIds.map((itemId, index) => [itemId, index])
    );

    return [...items].sort((left, right) => {
        const leftPosition = positionById.get(String(left._id));
        const rightPosition = positionById.get(String(right._id));

        if (
            typeof leftPosition === 'number' &&
            typeof rightPosition === 'number'
        ) {
            return leftPosition - rightPosition;
        }

        if (typeof leftPosition === 'number') return -1;
        if (typeof rightPosition === 'number') return 1;
        return 0;
    });
};

export const areSameOrder = (
    left: string[] = [],
    right: string[] = []
): boolean => {
    if (left.length !== right.length) return false;
    return left.every((item, index) => item === right[index]);
};
